/* eslint-disable @typescript-eslint/no-explicit-any */
function uiSelectConfig(config: any): void {

    // Default ui-select dropdown to down instead of auto (prevents it from going up on smaller screens)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    config.dropdownPosition = 'down';

}

uiSelectConfig.$inject = ['uiSelectConfig'];

export { uiSelectConfig };
